module.exports = __webpack_public_path__ + "static/img/maintanence.d4cd08f.png";